import { CursorArrowRaysIcon } from "@heroicons/react/24/solid";

interface Props {
  onClick: () => void;
}

export default function AudioContextNeedsTapOverlay({ onClick }: Props) {
  return (
    <div
      className="fixed inset-0 z-50 cursor-pointer bg-black/40"
      onClick={onClick}
    >
      <div
        className={
          "mx-auto flex min-h-screen max-w-4xl flex-col items-center justify-center p-2"
        }
      >
        <CursorArrowRaysIcon className="h-64 animate-bounce" />
        <div className={"font-brik text-2xl"}>Click Anywhere</div>
      </div>
    </div>
  );
}
